import { toRgba } from '../../../utils/to-rgba/to-rgba.js';
function rgba(color, alpha) {
  if (typeof color !== "string" || alpha > 1 || alpha < 0) {
    return "rgba(0, 0, 0, 1)";
  }
  if (color.startsWith("var(--")) {
    return color;
  }
  var _toRgba = toRgba(color),
    r = _toRgba.r,
    g = _toRgba.g,
    b = _toRgba.b;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
}
export { rgba };